module.exports = __webpack_public_path__ + "img/defaultEar.2586963f.svg";